import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { DETAIL_SHEET_CLASS } from "@/lib/sheet";
import { useIsMobile } from "@/hooks/useMediaQuery";
import LeadConversationPanel from "@/components/leads/conversation/LeadConversationPanel";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  leadId?: string;
};

// The panel resolves the lead's etapa options and ticket statuses from the lead's
// own pipeline, so the board has nothing to hand down here.
const ProspectoDrawer = ({ isOpen, onClose, leadId }: Props) => {
  const isMobile = useIsMobile();

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <SheetContent side="right" className={DETAIL_SHEET_CLASS}>
        <SheetTitle className="sr-only">Detalle de lead</SheetTitle>
        {/* The drawer runs at 70–75% of the viewport, which fits both columns from
            md up. On a phone it is full-width but far too narrow for two, so the
            perfil moves behind its header button. */}
        <LeadConversationPanel
          key={leadId}
          leadId={leadId}
          surface="tablero"
          profileInline={!isMobile}
          isActive={isOpen}
        />
      </SheetContent>
    </Sheet>
  );
};

export default ProspectoDrawer;
